import {call, put, take} from "redux-saga/effects";

import {Project} from "../../domain/model/project";
import {IProjectRepository} from "../../domain/repository/project_repository";

import {createProjectAPI} from "../../infra/api/service/project_api";
import {createApiClient, IApiClient} from "../../infra/api/client";

import {
    CustomerTutorialActionType,
    createCustomerTutorialActionCreator,
    ICustomerTutorialActionCreator,
} from "../action/customer_tutorial_action";

const apiClient: IApiClient = createApiClient();
const projectRepository: IProjectRepository = createProjectAPI(apiClient);
const actionCreator: ICustomerTutorialActionCreator = createCustomerTutorialActionCreator();

function* handleGetAllByRecommendProjectListInCustomerTutorial() {
    while (true) {
        yield take(CustomerTutorialActionType.REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST);
        const projectList: Project[] = yield call(getAllByRecommendProjectList);
        yield put(actionCreator.callbackGetAllByRecommendProjectListAction(true, projectList))
    }
}

const getAllByRecommendProjectList = () => {
    return projectRepository.getAllByRecommend()
};

export {handleGetAllByRecommendProjectListInCustomerTutorial}


// WEBPACK FOOTER //
// ./src/presentation/handler/customer_tutorial_handler.tsx